import React from 'react'
import update from 'immutability-helper'
import moment from 'moment'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import NavLink from '../../Routes/NavLink'

import { leases } from '../../../core/controllers/Leases'
import { modal } from '../../../core/utilities/modal'

export default class ExpiringLeases extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            leases: null,
            getDataAgain: false,
            reloadData: false
        };

        this.index = 0;
    }

    componentDidMount() {
        // #  We need to setup our slimScroll on our editing window
		jQuery(jQuery('.single-task-card .scroll-attach')).slimScroll({
            height: '250px',
			alwaysVisible: true
        });

        this.reloadData();
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.getDataAgain) {
            this.reloadData();
            nextState.getDataAgain = false;
        } else if (nextState.reloadData) {
            nextState.reloadData = false;
        }
    }

    componentDidUpdate() {
        jQuery(jQuery('.single-task-card .scroll-attach')).slimScroll({
            height: '250px',
			alwaysVisible: true
        });
    }

    reloadData() {
        var self = this;
        leases.getExpiringLeasesForCurrentMonth(function(response) {
            self.setState({
                leases: response.additional
            });
        });
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatExpirationDate(cell, row) {
        return moment(cell).format('MMM Do YYYY');
    }

    formatActionOptions(cell, row) {
        return (
            <NavLink to={'/lease/' + row.contract_id}>
                <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off">
                View
                </button>
            </NavLink>
        )
    }

    render(){
        const leases = this.state.leases;
        const isMinimized = this.props.isMinimized;
        if(!isMinimized) {
            return (
                <div class="card">
                    <div class="header">
                        <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                        <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.minimizeTask}><i class="pe-7s-angle-down"></i></button>
                        <h4 class="title" onClick={this.props.minimizeTask}>Expiring Leases For { moment().format('MMMM') }</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <div class="scroll-attach">
                            <div class="row">
                                <div class="col-md-12">
                                {leases != null && leases.length != 0 && (
                                    <BootstrapTable data={leases} version='4' striped search pagination>
                                        <TableHeaderColumn dataField='contract_data_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                        <TableHeaderColumn dataField='title' dataSort={ true }>Title</TableHeaderColumn>
                                        <TableHeaderColumn dataField='contract_expiration_date' dataFormat={this.formatExpirationDate} dataSort={ true }>Expiration</TableHeaderColumn>
                                        <TableHeaderColumn dataAlign='center' dataFormat={this.formatActionOptions}></TableHeaderColumn>
                                    </BootstrapTable>
                                )}
                                </div>
                            </div>
                        </div>
                        <div class="footer">
                            <div class="legend">
                                <NavLink to="/leases">
                                    <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill pull-right" autoComplete="off">
                                    View All Leases
                                    </button>
                                </NavLink>
                                <div class="clearfix"></div>
                            </div>
                            <hr/>
                            <div class="stats">
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div class="card">
                    <div class="header">
                        <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                        <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.maximizeTask}><i class="pe-7s-angle-up"></i></button>
                        <h4 class="title" onClick={this.props.maximizeTask}>Expiring Leases for { moment().format('MMMM') }</h4>
                        <p class="category"></p>
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/MultiTaskManager/Type/ExpiringLeases.jsx